import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=8f0dac6c&scoped=true&"
import script from "./PointDetail.vue?vue&type=script&lang=js&"
export * from "./PointDetail.vue?vue&type=script&lang=js&"
import style0 from "./PointDetail.vue?vue&type=style&index=0&id=8f0dac6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0dac6c",
  null
  
)

export default component.exports